export default "__VITE_ASSET__BZsxPGCf__"